import { useQuery } from "@tanstack/react-query";
import { QueryKeysEnum } from "../types/QueryKeysEnum";
import { getDevice } from "../generated-api/device";
import { useDeviceClient } from "./useDeviceClient";

export const useDevice = (
  installationId = "",
  deviceTwinId = "",
  throwOnError?: boolean | ((error: Error) => boolean),
) => {
  const client = useDeviceClient();

  const fetchDevice = async (installationId: string, deviceTwinId: string) => {
    const { data } = await getDevice({
      client,
      throwOnError: true,
      path: {
        installationId,
        deviceTwinId,
      },
    });

    return data;
  };

  const response = useQuery({
    queryKey: [QueryKeysEnum.Device, installationId, deviceTwinId],
    queryFn: async () => fetchDevice(installationId, deviceTwinId),
    throwOnError,
    enabled: Boolean(installationId) && Boolean(deviceTwinId),
  });

  return { ...response, asyncFetch: fetchDevice };
};
